/* eslint-disable  @typescript-eslint/quotes */

const InformativeText = {
  OM: {
    AuthCapital:
      'Maximum amount of funds a company can generate by selling shares.',
    paidCap: 'The total money invested by shareholders in your company.',
    baseYear: 'The starting year used for comparison of emission values.',
    targetYear:
      'The year by which you aim to reduce your greenhouse gas emissions to a specific level.',
    total_floor_space:
      'The entire area in sq.ft. of all the facilities & the head office.',
    total_no_of_employee:
      'Total number of employees across all the facilities & the head office.',
    total_no_of_vehicle:
      'Total number of vehicles owned by a company across all the facilities & the head office.',
    total_revenue:
      'The overall money earned from selling goods & services before subtracting any costs or expenses.'
  },
  FacilityInfo: {
    leased:
      'Renting or temporarily using something, like a house or a car, in exchange for payment.',
    asset_leased_name:
      'The owner of an asset that a company rents (leases) to another party through a lease agreement.',
    bioDiverse:
      'Areas where plants, animals, and their habitats are legally protected from human activities.',
    waterScaredArea: 'Area with very less water availability.'
  },
  Ownership: {
    equityShare: 'A percentage share in the profits of the company.',
    OC: 'Degree of authority over the day-to-day activities of a company.',
    FC: 'The authority to decide how a company spends its money and manage other financial decisions.',
    holdings: 'Parent company that owns a percentage share in other companies.',
    holding_percent:
      'The percentage of ownership the reporting company has in another company or the shares it holds in that company.'
  },
  supplierInfo: {
    upMain: `The company that supplies the raw materials or products used to create another company's 
    final product. e.g., suppliers of rubber, glass, and steel are upstream suppliers for a car manufacturer.`,
    downMain: `Company that receives a finished product from you to use or sell further down to the end customer, 
      like the store that sells your manufactured bicycles to riders.`,
    susSource:
      'Choosing eco-friendly materials and ethical suppliers for a greener future.',
    screenSupplier: `If the supplier is evaluated based on environmental criteria like pollution
       prevention, waste management, water usage, etc.`,
    supplyChainMain: `A network involving everything from procuring the raw material
       to getting the final product to delivering it to the end customer.`
  },
  IP: {
    electricity: {
      renewable: `Resources that can be used repeatedly as they are replenished 
        naturally over a short time e.g., wind, water, etc.`,
      nonRenewable:
        'Resources that will run out & cannot be replenished e.g., coal, natural gas, etc.'
    },
    refri:
      'Essential coolant in cooling systems, crucial for maintaining low temperatures.',
    supplyChain: {
      upstream: {
        distanceTravelled:
          'The distance for a one-way trip of raw material from the raw material source to the facility.'
      },
      downStream: {
        distanceTravelled:
          'The distance for a one-way trip of product from the production source to the consumption point.'
      },
      main: `A network involving everything from procuring the raw material to
      getting the final product to delivering it to the end customer.`
    },
    otherActivies: {
      TDLosses: `The electricity lost  during the process of transmitting
         and distributing power from power plants to consumers.`
    },
    travel: {
      emp: {
        empTravel: `Travelling done by an employee from their home to workplace and back.
              e.g., by train, bus, car, bike, walking, etc.`,
        distanceTravelled:
          'The one-way distance travelled by an employee from home to the office.'
      },
      bus: {
        distanceTravelled: `The one-way distance travelled by an employee from
         the starting point of the business trip to the final destination.`
      }
    },
    capitalGoods: {
      main: 'Durable items used by businesses to create other goods and services.',
      powerCap: 'Amount of electricity a system can handle or produce at once.',
      supSpecific: 'Choose this method for more specific results.'
    },
    waste: {
      landfill: 'Burying waste underground in designated areas.',
      incineration: 'Burning waste at high temperatures.',
      recycle:
        'Turning old stuff into new things so that they can be used again instead of throwing them away.',
      reuse: 'Using something again instead of throwing it away.',
      reclaimed: `Recovering the waste through new ways & turning them into useful
         resources. e.g., using food scraps to create compost for gardens.`
    }
  },
  AM: {
    upLeased: 'An asset you or your company takes on rents and uses it.',
    downLeased: 'An asset you or your company owns and lease it out to others.',
    assetName:
      'The owner of an asset that a company rents (leases) to another party through a lease agreement.',
    franchise:
      'A business setup where you get to use the name of a company & their ways of doing things & you pay them for it.'
  },
  InvestInfo: {
    equityMain: `When a company uses its own money to buy a share of ownership in something, hoping
       it will increase in value or provide future benefits.
       These can be investments in other companies, projects, or even things like solar panels for their own use.`,
    debtMain:
      'Lending money to a borrower in exchange for fixed interest payments.',
    projectFin: `Funding large, long-term projects without draining company resources
     & relying on the project's future cash flow 
    to repay lenders and investors.`
  },
  Product: {
    dce: 'Products that directly consume the energy. e.g., Motorcycle, Iron-press, etc.',
    faf: `Fuels are burned directly to generate energy (e.g., coal, natural gas, oil, etc) while feedstock are 
    materials that are processed into fuels or other products(crops, wood, etc).`,
    ggc: 'Products which either themselves are GHGs (e.g., methane cylinders) or contain GHGs in them.',
    ttl: 'Total expected uses of the product throughout its lifetime.',
    cost_to_production: 'Cost of producing one unit of the product.',
    selling_price: 'Price of selling one unit of the product.',
    sold_products: {
      totalLife: 'Total expected uses of the product throughout its lifetime.',
      GHG_per_product: `The amount of greenhouse gases emitted during 
      the production, use and disposal of a single product.`,
      GHG_percent:
        'The default amount of greenhouse gases emitted by a GHG contained product that cannot be utilized.'
    },
    eolt: {
      main: 'Methods used to dispose a product after its use. e.g., recycling, reusing, landfilling, etc.',
      landfill: 'Burying waste underground in designated areas.',
      incineration: 'Burning waste at high temperatures.',
      recycle:
        'Turning old stuff into new things so that they can be used again instead of throwing them away.',
      reuse: 'Using something again instead of throwing it away.',
      reclaimed: `Recovering the waste through new ways & turning them into useful resources.
         e.g., using food scraps to create compost for gardens.`
    },
    raw_material: {
      average: {
        recycled: `Materials that have been processed & transformed into new product after their
        initial use & then used as raw material. e.g., turning plastic bottles into polyester fabric for clothing.`,
        reused: `Materials which are used again in their original form to create
          new products without much transformation. e.g., using reclaimed bricks
           from demolished buildings to construct new walls.`,
        fresh: `Materials that are taken directly from nature and have not 
       been processed or used before. e.g., cotton, bauxite,etc.`
      },
      supplierSpec: {
        recycled: `Materials that have been processed & transformed into new product 
        after their initial use & then used as raw material. e.g., turning plastic bottles
         into polyester fabric for clothing.`,
        reused: `Materials which are used again in their original form to create
          new products without much transformation. e.g., using reclaimed bricks
           from demolished buildings to construct new walls.`,
        fresh: `Materials that are taken directly from nature and have not 
       been processed or used before. e.g., cotton, bauxite,etc.`
      }
    }
  },
  NZM: {
    generalized: {
      GHG_emission_intensity: `Amount of GHG emissions per floor space of all the facilities.
         Like x tons of CO2 emissions per sq. ft. of area.`,
      Total_GHG_emission_equity_based: `By multiplying the company's equity percentage by the total greenhouse gas 
      emissions, environmental impact  of company is calculated.`,
      Total_GHG_emission_operation_control_based: `By multiplying the company's operational control
       percentage by the total  greenhouse gas emissions, environmental impact  of company is calculated.`,
      Total_GHG_emission_financial_control_based: `By multiplying the company's  financial control percentage by 
      the total greenhouse gas emissions, environmental impact  of company is calculated.`,
      Highest_sources_of_water_consumption: `Displays the top 3 water sources used mostly, among 
      all available resources.`,
      Energy_consumption:
        'Total consumption of fuel and electricity across all the facilities.',
      Energy_intensity:
        'The total amount of fuel and electricity consumed per unit of floor space across all facilities.',
      Fuel_and_related_activities:
        'Emissions related to the electricity production per unit of electricity consumption.',
      Most_type_of_waste: 'Displays the top 3 most generated waste types.'
    },
    utility: {
      fuel: {
        Fuel_Consumption_per_Unit_of_Production_or_Revenue: `Amount of fuel consumed across facilities to produce a unit
        product or to generate unit amount of revenue of the company.`,
        Emission_intensity_per_unit_of_fuel_consumed:
          'Amount of GHG emissions in tCO2 for each ton of fuel consumed.',
        Frequency_of_inspections_for_fugitive_emission_sources: `Determining how often facilities check for leaks & 
        releases of unwanted gases from industrial equipments, pipes or storage tanks  & fix them.`,
        Fugitive_emissions: `Fugitive Emissions: Accidental leakages of gases like methane,etc from 
        industrial equipments,
         pipes or storage tanks into the atmosphere which can harm the environment.`,
        Company_owned_vehicle_fleet_size: `Total number of vehicles  a company directly owns and uses 
        for business purposes.`,
        Emissions_of_ozone_depleting_substances: `Emission of man-made chemicals that contribute to the depletion
         of the ozone layer.`,
        Stationary_combustion: `Stationary Emissions: Burning of fuels to generate electricity,
         steam, heat or power in stationary equipment.`,
        Mobile_combustion:
          'Vehicle Emissions: Burning of fuels by transportation devices.'
      },
      electricity: {
        Electricity_consumption_intensity: `Way to measure how much electricity a business consumes to create
         one unit of something across all the facilities
         per area of all the facilities.`,
        Emission_intensity_per_KWh_of_electricity_consumed: `Measure of the amount of greenhouse gas (GHG) released 
        to create one kilowatt-hour (kWh) of electricity that you use.`
      },
      water: {
        Water_consumption_by_water_scarce_area: `Total water consumption in litre in all facilities in areas with
         water scarcity.`,
        Water_withdrawn_per_floor_space:
          'Water extracted or taken from ground or surface water sources per sq. ft. of facility area.'
      },
      waste: {
        Waste_emissions: `Release of harmful & unwanted gases, liquids or solids into the atmosphere due to the
         improper handling and breakdown of waste materials. e.g., Smoke from factories, wastewater
          from industrial processes, etc.`,
        Waste_emissions_intensity: `Amount of waste emissions in tCO2 from per unit of waste generated
         across all the facilities.`,
        Waste_management_costs: `The cost required for managing the waste i.e., everything from collection and
         transportation to processing and disposal of waste.`
      }
    },
    supplyChain: {
      Top_Emission_Contributors: `The industries or activities that produce the largest amounts of
       greenhouse gases.`,
      Supplier_weightage: `Categorization of the organization's suppliers based on their greenhouse gas
       (GHG) emission levels as low, medium and high emitters.`,
      percent_suppliers_meeting_sustainability_criteria: `Percentage of the total suppliers screened
       based on environmental criteria.`,
      Sustainable_suppliers: `Suppliers who produce & provide goods or services that minimizes harm 
      to the environment, promoting eco-friendly practices.`,
      Supply_chain_emission: `GHG emissions released throughout the entire lifecycle of a 
      product from extracting the raw
       materials to the final use of product.`,
      Emissions_per_freight_delivered: `Amount of pollution released per unit of cargo or good successfully
       transported by land, sea or air.`
    },
    travel: {
      Average_emissions_by_trip:
        'The average amount of GHG emissions produced for each journey.',
      Total_emissions_of_employee_commute: `The overall amount of greenhouse gases released
       due to employees traveling to and from work.`,
      Average_emissions_per_employee_commute: `The ratio of employee travel emissions 
      to the total frequency of travel.`,
      Carbon_intensity_of_travel: `Total business travel emissions per total distance of travel 
      across all the facilities.`,
      Distance_per_employee_trip: `The ratio of the total distance travelled during business travel
       to the total number of business trips taken.`,
      The_ratio_of_the_total_distance_travelled_during_business_travel: `Ratio of total distance
       of employee travelling to and from work to the total number of employees.`
    },
    asset: {
      Emissions_from_leased_assets:
        'Total greenhouse gases released by equipment or the asset you rent.',
      Emissions_per_leased_assets:
        'Total GHG emissions from a leased asset per unit leased assets.',
      Franchise_Carbon_Intensity:
        'Total carbon emissions of franchise across all facilities.'
    },
    products: {
      Intermediate_and_Final_product_data: `Distribution of all the products 
      categorized as intermediate and final products.`,
      Distribution_of_all_the_products_categorized: `Percentage of total 
      recycled items that are collected and processed into new materials.`,
      Recycled_and_reused_input_material:
        'Percentage of total recycled items that are collected and processed into new materials.',
      Reclaimed_Products: `Percentage of total recycled & reused items that are collected and
       processed into input materials.`,
      Weight_end_of_life:
        ' Amount of usable material recovered from a product that has reached the end of its useful life.',
      Recyclability_Ratio:
        'Ratio of products sold to the product recycled post selling.'
    }
  }
};

export default InformativeText;
